export default {
  defaultProps: {
    variant: "filled",
    focusBorderColor: "brandPrimary.500",
  },
};
